import { useState } from "react";

import { Button, Pop, PopOver } from "@vimeo/iris/components";
import { DotsMenu } from "@vimeo/iris/icons";

import { ThumbnailType } from "vimeo";

import "./thumbnailcard.scoped.scss";
import classNames from "classnames";

interface Props {
    imgLink: string;
    baseLink: string;
    thumbnailUri: string;
    thumbnailType: ThumbnailType;

    active?: boolean;

    // Only used when thumbnail type is gif.
    createdOn?: number;
    duration?: number;

    onClick?: () => void;
    onEmbedInEmailClicked: (uri: string) => void;
    onDownloadOptionClicked: (baseLink: string) => void;
    onCopyOptionClicked: (baseLink: string) => void;
    onDeleteOptionClicked: (uri: string) => void;
}

export function ThumbnailCard(props: Props) {
    const [showMenu, setShowMenu] = useState(false);

    const {
        active,
        baseLink,
        imgLink,
        thumbnailUri,
        thumbnailType,
        createdOn,
        duration,
        onClick,
        onEmbedInEmailClicked,
        onDownloadOptionClicked,
        onCopyOptionClicked,
        onDeleteOptionClicked,
    } = props;

    const deleteLabel = <span style={{ color: "#DB2E2E" }}>Delete</span>;

    return (
        <div
            className={classNames([
                "slds-var-p-around_small",
                "thumbnail-card",
                thumbnailType,
                { active },
            ])}
            title={
                active
                    ? "Currently active for this video"
                    : "Click to mark as active for this video"
            }
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
        >
            <div style={{ display: "flex" }}>
                <img src={imgLink} alt="" />
            </div>
            <div
                className="slds-var-m-left_small"
                style={{
                    display: "flex",
                    flexFlow: "column nowrap",
                    justifyContent: "end",
                }}
            >
                <div
                    className="slds-var-m-top_small"
                    style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                    }}
                >
                    <div
                        className="slds-var-m-right_small"
                        style={{ display: "flex", flexFlow: "column nowrap" }}
                    >
                        {thumbnailType === "gif" && [
                            <div key="createdOn">
                                Created on{" "}
                                {new Date(createdOn! * 1000).toLocaleDateString(
                                    "en-US",
                                    {
                                        month: "short",
                                        day: "numeric",
                                        year: "numeric",
                                    }
                                )}
                            </div>,
                            <div key="duration" style={{ color: "#657987" }}>
                                Duration: {duration} seconds
                            </div>,
                        ]}
                        <Button
                            className="slds-var-m-right_small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEmbedInEmailClicked(thumbnailUri);
                            }}
                        >
                            Embed in email
                        </Button>
                    </div>
                    <PopOver
                        active={showMenu}
                        content={
                            <>
                                <Pop.List>
                                    <Pop.Item
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowMenu(false);
                                            onDownloadOptionClicked(baseLink);
                                        }}
                                        data-menuitem="true"
                                    >
                                        Download
                                    </Pop.Item>
                                    <Pop.Item
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowMenu(false);
                                            onCopyOptionClicked(baseLink);
                                        }}
                                        data-menuitem="true"
                                    >
                                        Copy link
                                    </Pop.Item>
                                    <Pop.Item
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowMenu(false);
                                            onDeleteOptionClicked(thumbnailUri);
                                        }}
                                        data-menuitem="true"
                                    >
                                        {deleteLabel}
                                    </Pop.Item>
                                </Pop.List>
                            </>
                        }
                    >
                        <Button
                            format="secondary"
                            icon={<DotsMenu />}
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowMenu(!showMenu);
                            }}
                        ></Button>
                    </PopOver>
                </div>
            </div>
        </div>
    );
}
